import { useState, useCallback, useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { getRandomQuote } from '@/components/easter-eggs/EasterEggQuotes';

export const useLogoClick = () => {
  const [clickCount, setClickCount] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);
  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (clickCount >= 5) {
      // Trigger easter egg
      setIsSpinning(true);
      
      toast(getRandomQuote(), {
        duration: 4000,
        className: 'font-medium',
      });

      // Reset after animation
      setTimeout(() => {
        setIsSpinning(false);
        setClickCount(0);
      }, 1000);
    }

    // Clear previous timer
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Reset counter after 2 seconds of no clicks
    timerRef.current = setTimeout(() => {
      setClickCount(0);
    }, 2000);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [clickCount]);

  const handleLogoClick = useCallback((e: React.MouseEvent) => {
    // Don't prevent default - allow navigation to work
    setClickCount(prev => prev + 1);
  }, []);

  return {
    handleLogoClick,
    isSpinning,
  };
};
